import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import { Panel } from "react-bootstrap";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";

import Section from "./Section";
import PlayerIcon from "../playerItemComponents/PlayerIcon";

import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

class List extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	handleListExpandAll(listIndex) {
		this.props.dispatch(
			playerActions.listExpandAll,
			listIndex
		);
	}

	handleListCollapseAll(listIndex) {
		this.props.dispatch(
			playerActions.listCollapseAll,
			listIndex
		);
	}

	render() {

		let self = this;
		let list = this.props.list;
		let i = this.props.listIndex;
		
		let sections = list.children.map((section, j) => {
			let sectionComponent;
			if ((Utils.isVisible(section))) {
				sectionComponent = <Section section={section} listIndex={i} sectionIndex={j} activity={this.props.activity} listStyles={list.styles} sectionStyles={section.styles} defaultNodeExpanded={this.props.defaultExpanded} />;
			}
			return sectionComponent;
		});

		let listCompletionColor = Utils.getCompletionStateColor(list.completionState);

		let listBody;
		let bottomLeftBorderRadius = "3px";
		if (list.expanded) {
			bottomLeftBorderRadius = "0px";
			listBody = <Panel.Body>
				{sections}
			</Panel.Body>;
		}

		let icon;
		if (list.iconType !== "" && !_.isUndefined(list.iconType)) {
			icon = <PlayerIcon entity={list} style={{ marginRight: "8px" }} />;
		}

		let _styles = {};
		let _titleStyles = {};

		const { resolvedStyles } = list;
		if (resolvedStyles) {
			if (resolvedStyles.list) {
				_styles = resolvedStyles.list;
			}

			if (resolvedStyles.title) {
				_titleStyles = resolvedStyles.title;
			}
		}

		// delete _titleStyles.fontSize;

		let listComponent = (Utils.isVisible(list)) ? <Panel key={"history-list" + i} bsStyle="default" defaultExpanded={true} style={{ maxWidth: this.props.defaultColumnWidth, width: "100%", borderColor: list.borderColor }}>
			<Panel.Heading style={_.assign({}, { padding: "0px", backgroundColor: list.backgroundColor, color: list.color, border: "none" }, _styles)}>
				<div style={{ display: "flex", flexDirection: "row"}}>
					<div className="player-panel-heading-completion-status" style={{ "backgroundColor": listCompletionColor, bottomLeftBorderRadius }}></div>
					<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}></div>
					<div className="player-panel-heading">
						<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
							{icon}
							<div className="player-panel-title" style={_titleStyles} onClick={() => { playerActions.toggleExpandNode(self.context.tree, i); }}>
								{list.name}
							</div>
						</div>
						<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
							<span title="Expand all" style={{ "cursor": "pointer", "marginRight": "10px" }} onClick={() => self.handleListExpandAll(i)}><FontAwesomeIcon icon="expand" /></span>
							<span title="Collapse all" style={{ "cursor": "pointer" }} onClick={() => self.handleListCollapseAll(i)}><FontAwesomeIcon icon="compress" /></span>
						</div>
					</div>
				</div>
			</Panel.Heading>
			{listBody}
		</Panel> : null;

		if (this.props.activity.firstLevel === "lists") {
			return listComponent;
		} else {
			return (
				<div key="sections-wrapper" style={{ margin: 10, overflow: "auto" }}>
					{sections}
				</div>
			);
		}
	}
}

List.contextTypes = {
	tree: PropTypes.baobab
};


export default branch({
	activityTheme: ["activity", "theme"],
	user: ["user"],
	defaultColumnWidth: ["appPreferences", "defaultColumnWidth"]
}, List);